import React from "react";
import { useNavigate } from "react-router-dom";

/* data import */

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";

import ChefThumbsWrapper from "../components/ChefThumbsWrapper";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const Chefs = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  const handleChefInfoClick = (value) => {
    navigate(`/chefs/${value}`);
  };

  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper chefs-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <ChefThumbsWrapper handleChefInfoClick={handleChefInfoClick} />
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default Chefs;
